import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import MultiSelect from "../../Selects/MultiSelect"

export default class FeeBuilderCancellationRules extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'cancellation_rules',
      'tab-pane': true
    });

    var all_cancellation_rules = this.props.all_cancellation_rules
    var inputs = []
    var disabled_inputs = []
    for(var i = 0; i < all_cancellation_rules.length; i++){
      var input = {
        label_primary: all_cancellation_rules[i].name,
        input_status: this.props.select_status,
        // status: this.props.select_status,
        id: all_cancellation_rules[i].id
      }

      inputs.push(input)
    }


    return(
      <div className={tabClasses} id="cancellation_rules">
        <div className="row">
          <div className="col-md-12">
            { inputs.length
            ?
              <MultiSelect
                header_primary="name"
                inputs={inputs}
                selected_inputs={this.props.cancellation_rules}
                onChange={this.props.onChangeCancellationRules}
                />
            :
              <div className="no-records">
                <span className="none">{I18n.t('none')}</span>
              </div>
            }
          </div>
        </div>

        {
          this.props.select_status == "disabled"
            ?

          <div className="row">
            <div className="col-md-12" >
              <div style={{color: 'red', fontStyle: 'italic'}}>{I18n.t('tax_amount_cancellation_rule_validation')}</div>
            </div>

          </div>
            :
          null
        }

      </div>
    )
  }
}
